// 언어별 주소: 국문은 루트(/about), 영문은 /en 아래(/en/about).
// 영문 페이지도 별도 주소로 사전 렌더링되어 구글이 영어 검색어(Ship IT Support 등)로 색인할 수 있습니다.
import type { Lang } from "@/lib/useLang";

export const isEnPath = (path: string) => path === "/en" || path.startsWith("/en/");

// "/en/about" → "/about", "/en" → "/"
export const stripEn = (path: string) => (isEnPath(path) ? path.slice(3) || "/" : path);

export const langOfPath = (path: string): Lang => (isEnPath(path) ? "en" : "ko");

// 사이트 내부 주소를 해당 언어 주소로: localize("/about#x", true) → "/en/about#x", localize("/#contact", true) → "/en#contact"
export function localize(to: string, en: boolean) {
  if (!to.startsWith("/")) return to;
  const m = /^([^?#]*)(.*)$/.exec(to)!;
  const base = stripEn(m[1] || "/");
  if (!en) return `${base}${m[2]}`;
  return `/en${base === "/" ? "" : base}${m[2]}`;
}
